import { Form, Formik } from "formik";
import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../../../atoms/Button";
import InputField from "../../../../atoms/InputField";
import { UPLOAD_FILE } from "../../../../../api/apiFiles";
import { REGISTER_DEBIT_REGISTER } from "../../../../../api/apiEmpresas";

const ModalCreateEstadoDeCuenta = ({ refetch, onClose, id, cuenta }) => {
    const [files, setFiles] = useState({
        pdfFactura: null,
        pdfComplemento: null,
        xmlFactura: null,
        xmlComplemento: null,
    });
    const [loading, setLoading] = useState(false);

    const initialValues = {
        month: "",
        payment_concept: "",
        num_factura: "",
        comment: "",
        total: 0,
        clientId: id,
    };

    const uploadFile = async (file, path) => {
        if (!file) return null;
        const { name: filename, type: mimetype } = file;
        const { url, s3Key } = await UPLOAD_FILE(id, filename, mimetype, path);

        await fetch(url, {
            method: "PUT",
            headers: { "Content-Type": mimetype },
            body: file,
        });

        return {
            s3Key,
            filename,
            mimetype,
            title: filename,
        };
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            const pdfFactura = await uploadFile(files.pdfFactura, "facturas/pdfFacturas/");
            const pdfComplemento = await uploadFile(files.pdfComplemento, "facturas/pdfComplementos/");
            const xmlFactura = await uploadFile(files.xmlFactura, "facturas/xmlFacturas/");
            const xmlComplemento = await uploadFile(files.xmlComplemento, "facturas/xmlComplementos/");
            const payload = {
                ...values,
                factura: {
                    pdfFactura,
                    pdfComplemento,
                    xmlFactura,
                    xmlComplemento,
                },
            };
            await REGISTER_DEBIT_REGISTER(payload);
            refetch();
            onClose();
            toast.success("Registro exitoso");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setLoading(false);
        }
    };

    const validate = (values) => {
        const errors = {};
        if (!values.month) errors.month = "La fecha es requerida";
        if (!values.payment_concept) errors.payment_concept = "El concepto de pago es requerido";
        if (!values.num_factura) errors.num_factura = "El numero de factura es requerido";
        if (values.total === null || values.total === undefined || values.total < 0) {
            errors.total = values.total < 0 ? "El monto no puede ser negativo" : "El monto es requerido";
        }
        return errors;
    };

    const servicesValues = [
        { label: "Asesoria contable", value: "Asesoria_contable" },
        { label: "Renta de sistema contable", value: "Renta_de_sistema_contable" },
        { label: "Supervisión contable de operaciones", value: "Supervision_contable_de_operaciones" },
        { label: "Auditoria fiscal", value: "Auditoria_fiscal" },
        { label: "Administración de buzón tributario", value: "Administracion_de_buzon_tributario" },
        { label: "Otros", value: "Otros" },
    ];

    const fileInputs = [
        { key: "pdfFactura", label: "Factura PDF", accept: "application/pdf" },
        { key: "pdfComplemento", label: "Complemento de pago PDF", accept: "application/pdf" },
        { key: "xmlFactura", label: "Factura XML", accept: ".xml" },
        { key: "xmlComplemento", label: "Complemento de pago XML", accept: ".xml" },
    ];

    return (
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate}>
                {({ values, setFieldValue, errors }) => (
                    <Form className="w-full flex flex-col items-center">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-3">
                            <InputField name="month" label="Fecha de pago" type="date" />
                            <InputField name="num_factura" label="Numero de factura" type="number" />
                            <div className="w-full">
                                <label className="block text-base font-bold text-gray-700">Concepto de pago</label>
                                <Select
                                    name="payment_concept"
                                    options={servicesValues}
                                    className="basic-multi-select border border-black rounded-lg"
                                    classNamePrefix="select"
                                    onChange={(option) => setFieldValue("payment_concept", option?.label || "")}
                                    value={servicesValues.find(opt => opt.label === values.payment_concept) || null}
                                />
                            </div>
                            <InputField name="comment" label="Comentario" />
                            <InputField name="total" label="Cantidad pagada" type="number" />
                            {fileInputs.map(({ key, label, accept }) => (
                                <div key={key} className="flex flex-col items-start">
                                    <label className="font-semibold">{label}</label>
                                    <input
                                        className="border p-2 rounded-xl border-black w-full"
                                        type="file"
                                        accept={accept}
                                        onChange={(e) => setFiles({ ...files, [key]: e.target.files[0] })}
                                    />
                                </div>
                            ))}
                        </div>
                        <Button
                            text={loading ? <PropagateLoader color="red" /> : "Registrar"}
                            type="submit"
                            disabled={loading}
                            bgColor="blue"
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ModalCreateEstadoDeCuenta;